import Faq from './Faq';
import HowTo from './HowTo';
import Join from './Join';
import InputBar from './InputBar';
import GeneratedBlogNames from './GeneratedBlogNames';
import { useState } from 'react';
import BlogNameDialog from './BlogNameDialog';
import TfHighlights from './TfHighlights';
import NicheNameIdeas from './NicheNameIdeas';
import NamingTips from './NamingTips';

export default function BlogNameGenerator() {
  const [nameOpen, setNameOpen] = useState(false);

  return (
    <>
      <InputBar setNameOpen={setNameOpen} />
      <HowTo />
      <TfHighlights />
      <GeneratedBlogNames setNameOpen={setNameOpen} />
      <NicheNameIdeas setNameOpen={setNameOpen} />
      <NamingTips />
      <Join />
      <Faq />
      <BlogNameDialog open={!!nameOpen} setOpen={setNameOpen} name={nameOpen} />
    </>
  );
}
